<template>
  <span>
    <slot name="button" v-bind="{ onclick: toggle }">
      <b-button variant="primary" class="mr-1" size="xs" @click="toggle"><i
          class="fas fa-edit"></i>&nbsp;Edit</b-button>
    </slot>

    <b-modal @show="resetModal" @hidden="resetModal" ref="modal-container" v-model="modalShow" size="lg" :title="title"
      :static="true" :lazy="true" hide-footer>
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group :label="type !== 'checkbox' ? label : null" :label-for="`${id}-input`"
          v-for="({ id, label, validate = {}, type, disabled = false, options, placeholder = null }) in inputs"
          :key="id">
          <b-form-input v-if="type === 'string'" :id="`${id}-input`" v-model="formValues[id]" v-validate="validate"
            :placeholder="placeholder" :state="validateState(id)" :aria-describedby="`${id}-live-feedback`"
            :data-vv-name="id" :data-vv-as="label" autocomplete="off" :disabled="disabled" />
          <b-form-input v-if="type === 'number'" type="number" :id="`${id}-input`" v-model="formValues[id]"
            v-validate="validate" :state="validateState(id)" :aria-describedby="`${id}-live-feedback`"
            :data-vv-name="id" :data-vv-as="label" autocomplete="off" :disabled="disabled" />
          <multiselect v-if="type === 'select'" :id="`${id}-input`" v-model="gameTypeModel" v-validate="validate"
            label="name" track-by="id" :options="options" :aria-describedby="`${id}-live-feedback`" :data-vv-name="id"
            :data-vv-as="label" autocomplete="off" :disabled="disabled" />

          <template v-if="type === 'json'">
            <v-jsoneditor ref="value-editor" v-model="formValues[id]"
              :options="{ mode: 'code', enableSort: false, enableTransform: false }" :plus="false" />

            <b-form-input id="value-editor-error" v-model="valueEditorError" v-validate="{ is: '' }"
              :state="validateState('value-editor-error')" aria-describedby="value-editor-error-live-feedback"
              data-vv-name="value-editor-error" data-vv-as="Value" hidden autocomplete="off" />

            <b-form-invalid-feedback id="value-editor-error-live-feedback" v-if="veeErrors.first('value-editor-error')">
              {{ valueEditorError }}
            </b-form-invalid-feedback>
          </template>
        </b-form-group>

        <b-form-invalid-feedback id="value-editor-error-live-feedback" v-if="veeErrors.first('value-editor-error')">
          {{ valueEditorError }}
        </b-form-invalid-feedback>

      </form>

      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit">Save</b-button>
    </b-modal>
  </span>
</template>

<script>
import { getRouteIcon, ROUTE_AGGR_CONFIGS } from "../../utils/routerIcons";
import Vue from "vue";
import Multiselect from "vue-multiselect";
import VJsoneditor from "v-jsoneditor/src/index";

export default {
  data() {
    return {
      gameTypeOption: [],
      modalShow: false,
      formValues: this.getInitialValues(),
      valueEditorError: '',
      gameTypeModel: null,
    }
  },
  components: {
    Multiselect,
    VJsoneditor,
  },
  props: {
    create: Boolean,
    title: String,
    defaultValues: Object
  },
  methods: {
    validatorTag(tag) {
      return /^\d+\.?\d*$/.test(tag);
    },
    getInitialValues() {
      return {
        id: null,
        partnerId: '',
        gameType: null,
        token: '',
        salt: '',
        settings: {},
      };
    },
    setDefaults() {

      let initialValues = this.getInitialValues();

      for (let field in initialValues) {
        Vue.set(this.formValues, field, initialValues[field]);
      }
      if (this.defaultValues) {
        for (let field in this.defaultValues) {

          Vue.set(this.formValues, field, this.defaultValues[field]);
        }
      }

      this.gameTypeModel = this.gameTypeOption.find(({ id }) => id === this.formValues.gameType)
    },
    validateState() {
      //// return this.veeErrors.has(ref);
      //
      // if (
      //     this.veeFields[ref] &&
      //     (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      // ) {
      //   return !this.veeErrors.has(ref);
      // }
      return null;
    },
    resetModal() {
      this.setDefaults();
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    handleSubmit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        this
          .$http({
            url: this.create ? '/api/v1/partners-settings' : '/api/v1/partners-settings/' + this.formValues.id,
            data: { ...this.formValues, gameType: this.gameTypeModel.id },
            method: this.create ? 'POST' : 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then(() => {
            setTimeout(() => {
              this.$emit('finish')
            }, 500);

            this.hideModal();
            this.$toastr.i('Success');
          })
          .catch((err) => {
            this.$toastr.e(JSON.stringify(err.response.data.message));

            throw err;
          });
      });
    },
  },
  computed: {
    inputs() {
      let inputs = [
        { id: 'partnerId', label: 'Operator ID', validate: { required: false }, type: 'string' },
        {
          id: 'gameType',
          label: 'Game Type',
          options: this.gameTypeOption,
          validate: { required: false },
          type: 'select'
        },
        { id: 'token', label: 'Token', validate: { required: true }, type: 'string' },
        { id: 'settings', label: 'Settings', validate: { required: true }, type: 'json' },

      ];

      if (this.create) {
        return inputs;
      }

      return [
        { id: 'id', label: '_ID', validate: { required: true }, type: 'string', disabled: true },
        ...inputs,
      ];
    },
    routeIcon: () => getRouteIcon(ROUTE_AGGR_CONFIGS),
  },
  async beforeMount() {
    await this.$store.dispatch('gameTypes/loadList').then(() => {
      this.gameTypeOption = this.$store.getters['gameTypes/list'].map(({ name, id }) => {
        return { name, id }
      });
    });
  },
  mounted() {
    this.setDefaults();
  },
}
</script>
